/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import counterpart from 'counterpart';
import uniqBy from 'lodash/uniqBy';
import {produce} from 'immer';

import HollowButton from 'Components/Button/HollowButton';
import PrimaryButton from 'Components/Button/PrimaryButton';
import CloseIcon from 'Components/icons/CloseIcon';
import * as organizationActions from 'Actions/organizationActions';
import OrgHierarchySelectorAccountsRow from './OrgHierarchySelectorAccountsRow';

import { GPNOrgTypes, getBlankHierarchyRow, getBlankHierarchyRowGpn,getBlankHierarchyRowEvo, getBlankHierarchyRowHpy, getBlankHierarchyRowGpe, EVOOrgTypes, HPYOrgTypes, GPEOrgTypes } from 'Utils/organizationAccountsUtils';
import 'Containers/DataAccessFilter/DataAccessFilter.scss';

class OrgHierarchySelectorAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchantCount: null,
      firstThreeSelectedMerchantNumbers: [],
      hierarchyRows: this.props.hierarchyRows,
      resetCount: this.props.resetCount,
      receivedCurrentFilter: true,
    };
    this.merchantCountCalls = [];
    this.loadOrganizationCalls = [];
    this.attachBindings();
  }

  componentWillReceiveProps(newProps) {
    if (this.state.resetCount < newProps.resetCount) {
      this.setState({ hierarchyRows: [], resetCount: newProps.resetCount },
        () => this.setState({ hierarchyRows: newProps.hierarchyRows }));
    }
    else if(this.props.hierarchyRows && JSON.stringify(this.props.hierarchyRows)!=JSON.stringify(newProps.hierarchyRows)){  
      this.setState({ hierarchyRows: newProps.hierarchyRows });
    }
    if(newProps.hierarchyRows.some(e => e.selectedOrgIds.length === 0)){
      this.setState({receivedCurrentFilter: false});
    }
  }

  componentDidMount(){
    if (this.state.hierarchyRows.length === 0) {
      this.state.hierarchyRows = this.props.canViewGpnAccountsSelector ? [getBlankHierarchyRowGpn(0)] : this.props.canViewHpyAccountsSelector ? [getBlankHierarchyRowHpy(0)] : this.props.canViewGpeAccountsSelector ? [getBlankHierarchyRowGpe(0)] : this.props.canViewEvoAccountsSelector ? [getBlankHierarchyRowEvo(0)] : [getBlankHierarchyRow(0)];
       this.setState({receivedCurrentFilter: false});
     }
   }

  onHierarchySelectionChanged(key, selectedOrgIds, manualSearchMid,row) {
    // update row in hierarchy, and maintain the sort by key on the array so rows in UI don't rearrange
    this.setState((prevState) => {
      const newState = {
        hierarchyRows: [
          ...prevState.hierarchyRows.filter((r) => r.key !== key),
          { key, selectedOrgIds, manualSearchMid, row},
        ].sort((a, b) => a.key - b.key),
      };
      this.updateMerchantSummary(newState).then(() => this.props.hierarchyRowChangedCallback(newState.hierarchyRows, this.state.merchantCount, this.state.firstThreeSelectedMerchantNumbers));
      return newState;
    });
  }

  getAccessibleOrgsFromHierarchyRoot(hierarchyCode) {
    const orgs = this.props.cachedLoginUserOrgs[hierarchyCode];
    if (!orgs) return [];
    const accessibleOrgs = orgs.filter(x => x.orgId);
    const nonAccessiblePlacholderOrgs = orgs.filter(x => !x.orgId && x.hierarchyCode);
    return [].concat(accessibleOrgs, ...nonAccessiblePlacholderOrgs.map(x =>  this.getAccessibleOrgsFromHierarchyRoot(x.hierarchyCode)));
  }

  // finds the first three merchant numbers currently selected for display summary
  getSelectedMerchantNumbers(state) {
    let merchantNumbers = this.deepFlat([...state.hierarchyRows.map(merchantno => {
      if(merchantno.row&&merchantno.row[this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT]){
      const selectedItems = merchantno.row[this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT].selectedItems;
      const items = merchantno.row[this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT].items.filter(item => item.hierarchyCode !== 'All');
      if (selectedItems.length > 0) return selectedItems.slice(0, 3).map(selectedItem => merchantno && selectedItem.mainLine);
      if (items.length > 0) return items.slice(0, 3).map(item => item && item.mainLine);
      }
      return [];
    })]);
    const hierarchyRoots = this.getUniqueOrgHierarchyRoots(state);
    const directAccessMerchants = this.deepFlat(hierarchyRoots.map(h => this.getTopLevelDirectOrganizations(h.hierarchyCode).filter(m => m.OrgType === 'MERCHANT').map(m => m.merchant)));
    merchantNumbers = merchantNumbers.concat(directAccessMerchants);
    return merchantNumbers.slice(0, 3);
  }

  // get the count of all individually selected merchants that do not have an hierarchal ancestor found in the selectedHierarchyOrgs
  getLoadedMerchantCount(state, selectedHierarchyOrgs) {
    const merchants = this.deepFlat(state.hierarchyRows
          .filter(r =>r.row&& r.row[ this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT] && r.row[this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT].selectedItems.length > 0)
          .map(r => r.row[this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT].selectedItems.filter(i => !selectedHierarchyOrgs.some(h => i.parentHierarchyCode.indexOf(h.hierarchyCode) > -1))));
    const uniqueMerchants = uniqBy(merchants, 'mainLine');
    return uniqueMerchants.length;
  }

  // get a unique list of each directly selected organization (i.e., the most specific, right-most selection on each row)
  getUniqueOrgHierarchyRoots(state) {
    // get the list of directly selected orgs from each row
    const orgs = this.deepFlat(state.hierarchyRows.map(r => {
      if(r.row){
      const column = r.row.slice().reverse().find(c => c.selectedItems.length === 1 && r.row[ this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT].selectedItems.length === 0);
      if (column && column.selectedItems) {
        const c = column.selectedItems[0].orgId ? column.selectedItems[0] : this.getAccessibleOrgsFromHierarchyRoot(column.selectedItems[0].hierarchyCode);
        return c;
      }
    }
      return [];
    })).filter(x => x);

    // filter orgs that have an ancetor org in the direct selections
    if (orgs.length) {
      const uniqueOrgs = uniqBy(orgs.filter(o => o.orgType !== (this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT)), 'hierarchyCode').filter(o => !orgs.some(p => p.hierarchyCode && o.hierarchyCode.indexOf(p.hierarchyCode) > -1 && o.hierarchyCode.length > p.hierarchyCode.length));
      const uniqueMerchants = uniqBy(orgs.filter(o => o.orgType === (this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT)), 'merchantNumber');
      return uniqueOrgs.concat(uniqueMerchants);
    }
    return [];
  }

  getMerchantCountApiPromise(parentOrgId, parentHierarchyCode) {
    const existingCall = this.merchantCountCalls[parentHierarchyCode];
    if (existingCall) return existingCall;

    this.merchantCountCalls[parentHierarchyCode] = this.props.orgActions.getMerchantCount({ parentHierarchyCode, parentOrgId });
    return this.merchantCountCalls[parentHierarchyCode];
  }

  getMerchantCount(parentOrgId, parentHierarchyCode) {
    const cacheKey = parentHierarchyCode;
    if (!parentOrgId) {
      const orgs = this.getAccessibleOrgsFromHierarchyRoot(parentHierarchyCode);
      const merchantOrgs = orgs.filter(o => o.merchantNumber);
      const hierarchyOrgs = orgs.filter(o => !o.merchantNumber);

      const promises = hierarchyOrgs.map(o => {
        const childOrgCount = this.props.cachedMerchantCounts[o.hierarchyCode];
        if (childOrgCount) {
          return new Promise((resolve) => resolve(childOrgCount));
        }
        return this
          .getMerchantCountApiPromise(o.orgId, o.hierarchyCode)
          .then(() => this.props.cachedMerchantCounts[o.hierarchyCode]);
      });
      promises.push(new Promise((resolve) => resolve(0)));
      return Promise.all(promises)
        .then((counts) => merchantOrgs.length + counts.reduce((sum, count) => sum + count));
    } else {
      const merchantCount = this.props.cachedMerchantCounts[cacheKey];
      if (merchantCount) return new Promise((resolve) => resolve(merchantCount));
      return this
        .getMerchantCountApiPromise(parentOrgId, parentHierarchyCode)
        .then(() => this.props.cachedMerchantCounts[cacheKey]);
    }
  }

  // update the total count of merchants selected and the first three selected merchants based on the current selections
  updateMerchantSummary(state) {
    state.firstThreeSelectedMerchantNumbers = this.getSelectedMerchantNumbers(state).filter(x => x);
    const orgsToCount = this.getUniqueOrgHierarchyRoots(state);
    const loadedMerchantCount = this.getLoadedMerchantCount(state, orgsToCount);
    const promises = orgsToCount.map(org => this.getMerchantCount(org.orgId, org.hierarchyCode));
    if (promises.length) {
      return Promise.all(promises)
        .then(counts => {
          this.setState(produce(draft => {
            if (counts) draft.merchantCount = counts.reduce((sum, c) => sum + c, 0) + loadedMerchantCount;
          }));
        });
    }
    this.setState(produce(draft => {
      draft.merchantCount = loadedMerchantCount;
      draft.isCounting = false;
    }));
    return new Promise(resolve => resolve(loadedMerchantCount));
  }

  getTopLevelDirectOrganizations(hierarchyCodeFilter) {
    const orgKeysCached = this.props.cachedLoginUserOrgs;
    // original logic to handle all selections above chain level
    if (hierarchyCodeFilter && hierarchyCodeFilter.length < 14) {
      const orgs = this.deepFlat(Object
        .getOwnPropertyNames(orgKeysCached)
        .filter(code => code.length < 14)
        .map(code => orgKeysCached[code]));

      const orgsToSearch = orgs
        .filter(o => o.orgId
            && (o.hierarchyCode.indexOf(hierarchyCodeFilter) === 0 ||
              (o.orgType === (this.props.canViewHpyAccountsSelector ? HPYOrgTypes.MERCHANT : this.props.canViewEvoAccountsSelector ? EVOOrgTypes.MERCHANT : this.props.canViewGpeAccountsSelector ? GPEOrgTypes.MERCHANT : GPNOrgTypes.MERCHANT) && o.parentHierarchyCode.indexOf(hierarchyCodeFilter) === 0)));

      const topLevel = orgsToSearch
        .filter(o => !orgsToSearch.some(any =>
                  any.orgId
                  && any.hierarchyCode.length < o.hierarchyCode.length
                  && o.hierarchyCode.indexOf(any.hierarchyCode) === 0));
      return topLevel;
    } else { // improve performance for specific case of selecting merchants (which can be very large arrays)
      const topLevel = orgKeysCached[hierarchyCodeFilter];
      return topLevel || [];
    }
  }

  addAnotherFilter() {
    const hierarchyRows = this.state.hierarchyRows;
    const nextKey = hierarchyRows.reduce((max, cur) => { return (max > cur.key) ? max : cur.key; }, 0) + 1;
    const newRow = this.props.canViewGpnAccountsSelector ? getBlankHierarchyRowGpn(nextKey) : this.props.canViewHpyAccountsSelector ? getBlankHierarchyRowHpy(nextKey) : this.props.canViewGpeAccountsSelector ? getBlankHierarchyRowGpe(nextKey) : this.props.canViewEvoAccountsSelector ? getBlankHierarchyRowEvo(nextKey) : getBlankHierarchyRow(nextKey);
    const newRows = [...hierarchyRows, newRow];
    this.setState({ hierarchyRows: newRows }, this.props.hierarchyRowChangedCallback(newRows, this.state.merchantCount, this.state.firstThreeSelectedMerchantNumbers));
  }

  deleteFilter(key) {
    if (this.state.hierarchyRows.length > 1) {
      this.setState(produce(draft => {
        draft.hierarchyRows = draft.hierarchyRows.filter(r => r.key !== key);
        this.updateMerchantSummary(draft).then(() => this.props.hierarchyRowChangedCallback(this.state.hierarchyRows, this.state.merchantCount, this.state.firstThreeSelectedMerchantNumbers));
      }));
    }
  }

  deepFlat = (products) => {
    return products.reduce((prod, val) => Array.isArray(val) ? prod.concat(this.deepFlat(val)) : prod.concat(val), []);
  };

  attachBindings() {
    this.addAnotherFilter = this.addAnotherFilter.bind(this);
    this.onHierarchySelectionChanged = this.onHierarchySelectionChanged.bind(this);
    this.getMerchantCount = this.getMerchantCount.bind(this);
    this.getMerchantCountApiPromise = this.getMerchantCountApiPromise.bind(this);
    this.getAccessibleOrgsFromHierarchyRoot = this.getAccessibleOrgsFromHierarchyRoot.bind(this);
    this.getLoadedMerchantCount = this.getLoadedMerchantCount.bind(this);
    this.getSelectedMerchantNumbers = this.getSelectedMerchantNumbers.bind(this);
    this.updateMerchantSummary = this.updateMerchantSummary.bind(this);
    this.getUniqueOrgHierarchyRoots = this.getUniqueOrgHierarchyRoots.bind(this);
    this.getTopLevelDirectOrganizations = this.getTopLevelDirectOrganizations.bind(this);
  }

  render() {
    const isSupportProvider = false;
    const isExternalUser = false;
    const dottedBorderClass = isExternalUser ? 'button-hollow-dottedBorderMultiChain' : 'button-hollow-dottedBorder';
    const selectorConfig = this.props.canViewGpnAccountsSelector ?
    {
      corp: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
      region: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all') , required: true },
      principal: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
      associate: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
      chain: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
      merchant: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
    } : this.props.canViewHpyAccountsSelector ? {
      chain: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
    
      merchant: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
    } : this.props.canViewGpeAccountsSelector ? {
      opco: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
      acquirer: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
      contract: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
      merchant: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
    } : {
      chain: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: false },
      group: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all') , required: false },
      taxid: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
      merchant: { defaultsTo: counterpart('globalTranslate.globalSelectorFlag.all'), required: true },
    };

    // force sort by key so it doesn't randomly rearrange the rows
    const rows = this.state.hierarchyRows.map((r) => {
      return (
        <div key={`row_${r.key}`} className="data-access-filter-chain-horizontal global-selector-accordion">
          <OrgHierarchySelectorAccountsRow
            key={r.key}
            rowKey={r.key}
            initialSelections={r.row}
            selectorConfig={selectorConfig}
            hierarchySelectionCallback={this.onHierarchySelectionChanged}
            getMerchantCount={this.getMerchantCount}
            targetRole={this.props.targetRole}
            enableLazyLoading={this.props.enableLazyLoading}
            accordionErrors={this.props.accordionErrors}
            isGlobalSelector={this.props.isGlobalSelector}
            getDirectTopLevelOrganizations={this.getTopLevelDirectOrganizations}
            prepopulatedMerchantId={this.props.prepopulatedMerchantId}
            canViewGpnAccountsSelector={this.props.canViewGpnAccountsSelector}
            canViewEvoAccountsSelector={this.props.canViewEvoAccountsSelector}
            canViewHpyAccountsSelector={this.props.canViewHpyAccountsSelector}
            canViewGpeAccountsSelector={this.props.canViewGpeAccountsSelector}
            canViewHierarchySelector={this.props.canViewHierarchySelector}
            receivedCurrentFilter={this.state.receivedCurrentFilter}
            manualSearchMid={r.manualSearchMid}
          />
          {this.props.enableAddMoreButton && < div className="delete-access hidden-l">
            <PrimaryButton
            key={`delete_${r.key}`}
            action={() => this.deleteFilter(r.key)}
            extraClass="button-primary-deleteButton"
          >
            <CloseIcon />
          </PrimaryButton>
        </div>
      }
        </div>
      );
    });
    return (
      <div>
        <div className="global-selector">
          {rows}
        </div>
        {!isSupportProvider && this.props.enableAddMoreButton &&
          <div className="global-selector-addmore">
            <HollowButton
              action={this.addAnotherFilter}
              disabled={false}
              extraClass={dottedBorderClass}
            >
              <span className="addMore">+</span>
              <span className="addMore">{counterpart('globalTranslate.globalSelector.addMore')}</span>
            </HollowButton>
            <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '26em' }}>
              {this.props.callOnBoardContainer &&
                <OnboardingHierarchy
                  topicKey="Selection"
                  extraClass="selection"
                />
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

OrgHierarchySelectorAccounts.propTypes = {

  // set by consumers of this component
  hierarchyRows: PropTypes.array,
  hierarchyRowChangedCallback: PropTypes.func.isRequired,
  callOnBoardContainer: PropTypes.bool,
  selectorConfig: PropTypes.object,
  resetCount: PropTypes.number.isRequired,
  targetRole: PropTypes.string,
  enableLazyLoading: PropTypes.bool,
  accordionErrors: PropTypes.number,
  updateErrorStatus: PropTypes.func,
  isGlobalSelector: PropTypes.bool,
  receivedCurrentFilter: PropTypes.bool,

  // set by redux infrastructure
  orgActions: PropTypes.object.isRequired,
  loginUserId: PropTypes.number.isRequired,
  cachedLoginUserOrgs: PropTypes.object.isRequired,
  cachedMerchantCounts: PropTypes.object.isRequired,

};

OrgHierarchySelectorAccounts.defaultProps = {
  callOnBoardContainer: true,
  selectorConfig: {
    corp: { defaultsTo: 'All', required: false },
    region: { defaultsTo: 'All', required: false },
    principal: { defaultsTo: 'All', required: false },
    associate: { defaultsTo: 'All', required: false },
    chain: { defaultsTo: 'All', required: false },
    merchant: { defaultsTo: 'All', required: false },
   
  },
  hierarchyRows: [getBlankHierarchyRow(0)],
  targetRole: '',
  enableLazyLoading: false,
  isGlobalSelector: false,
  accordionErrors: 0,
  updateErrorStatus: () => {},
  receivedCurrentFilter: false,
};

const mapStateToProps = (state) => ({
  loginUserId: state.auth.user.userId,
  loginUserRoleKey: state.auth.user.role.key,
  cachedLoginUserOrgs: state.organization?state.organization.cachedLoginUserOrgs:[],
  cachedMerchantCounts: state.organization?state.organization.cachedMerchantCounts:0,
  isFetching:state.organization&& state.organization.isFetching,
});

const mapDispatchToProps = (dispatch) => {
  return {
    orgActions: bindActionCreators(organizationActions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrgHierarchySelectorAccounts));
